export default __webpack_public_path__ + "static/media/images.bec8fa3e.svg";